import type { FC } from 'react';
import { StickyContainer } from 'react-sticky';

import styles from './TablePage.module.scss';

export const TablePage: FC = ({ children }) => (
  <div className={styles.Page}>
    <StickyContainer>{children}</StickyContainer>
  </div>
);
